<template>
  <div>
    <h1>机构用户</h1>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
    computed: {

    },
    methods: {

    }
  }

</script>
